//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.AdyenSession
import com.tixforgigs.apax.models.PaymentState
import com.tixforgigs.apax.models.PaymentTypeId
import com.tixforgigs.apax.models.PaypalSession

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The order response model
* 
* @param orderId The order id
* @param orderToken The order token
* @param paymentState 
* @param adyenSession 
* @param availablePaymentTypes The available payment methods
* @param orderExpires The order timeout as utc date time
* @param paypalSession 
*/
@Serializable

data class OrderResponse (


      /* The order id */
    @SerialName(value = "orderId") @Required val orderId: kotlin.Int,


      /* The order token */
    @SerialName(value = "orderToken") @Required val orderToken: kotlin.String,


      @SerialName(value = "paymentState") @Required val paymentState: PaymentState,


      @SerialName(value = "adyenSession") val adyenSession: AdyenSession? = null,


      /* The available payment methods */
    @SerialName(value = "availablePaymentTypes") val availablePaymentTypes: kotlin.collections.List<PaymentTypeId>? = null,


      /* The order timeout as utc date time */
    @SerialName(value = "orderExpires") val orderExpires: kotlin.time.Instant? = null,


      @SerialName(value = "paypalSession") val paypalSession: PaypalSession? = null


) {




  }

